import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import {
  oatCookingTypeOptions,
  oatTypeOptions,
  oatVarietyOptions,
} from './constants'
import Select from 'react-select'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotAlpha } from 'context/Utilities'

const OatsOatmealPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    GrainSize: item.GrainSize,
    OatType: item.OatType,
    CookingType: item.CookingType,
    OatVariety: item.OatVariety,
  })

  const tempType = {
    value: item.OatType,
    label: item.OatType,
  }
  const tempVariety = {
    value: item.OatVariety,
    label: item.OatVariety,
  }

  const containsType = oatTypeOptions.some(e => {
    return JSON.stringify(tempType) === JSON.stringify(e)
  })

  const containsVariety = oatVarietyOptions.some(e => {
    return JSON.stringify(tempVariety) === JSON.stringify(e)
  })

  if (containsVariety) {
    packaging.OatVariety = item.OatVariety
  } else {
    packaging.OatVariety = 'Other'
    packaging.otherVariety = item.OatVariety
    item.otherVariety = item.OatVariety
    item.OatVariety = 'Other'
  }
  if (containsType) {
    packaging.OatType = item.OatType
  } else {
    packaging.OatType = 'Other'
    packaging.otherType = item.OatType
    item.otherType = item.OatType
    item.OatType = 'Other'
  }

  const methods = useFormContext()
  const { setSelectReviewer, onChangeReviewer, asterisk } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      console.log('item is: ' + JSON.stringify(item))
      const {
        fkCategory,
        fkSubCategory,
        GrainSize,
        OatType,
        CookingType,
        OatVariety,
      } = item
      setPackaging({
        fkCategory,
        fkSubCategory,
        GrainSize,
        OatType,
        CookingType,
        OatVariety,
      })
    }
    // eslint-disable-next-line
    }, [item])
  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Oat Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={oatTypeOptions}
          defaultValue={{ label: packaging.OatType, value: packaging.OatType }}
          name="OatType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Oat Type'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            setPackaging({
              ...packaging,
              OatType: value,
            })
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="OatType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        {item.OatType === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Type (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="otherType"
              placeholder={'Other Type'}
              defaultValue={item.otherType}
              control={methods.control}
              rules={{ required: true }}
              onKeyDown={e => {
                if (isNotAlpha(e.key) && e.key !== ' ') {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="otherType"
                message={'Other type is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            name="GrainSize"
            placeholder={'Grain Size'}
            defaultValue={packaging.GrainSize}
            control={methods.control}
            rules={{ required: true, maxLength: 15 }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={true}
          />
          <p className={'text-danger'}>
            {methods.errors.GrainSize &&
              methods.errors.GrainSize.type === 'required' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Grain size is required.
                </Alert>
              )}
            {methods.errors.GrainSize &&
              methods.errors.GrainSize.type === 'maxLength' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Grain size exceeds 15 characters.
                </Alert>
              )}
          </p>{' '}
        </FormGroup>
      </Col>
      <Col xs={6}>
        <p>
          <strong>Oat Variety {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={oatVarietyOptions}
          defaultValue={{
            label: packaging.OatVariety,
            value: packaging.OatVariety,
          }}
          name="OatVariety"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Oat Variety'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            setPackaging({
              ...packaging,
              OatVariety: value,
            })
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="OatVariety"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        {item.OatVariety === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Variety (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="otherVariety"
              placeholder={'Other Variety'}
              defaultValue={item.otherVariety}
              control={methods.control}
              rules={{ required: true }}
              onKeyDown={e => {
                if (isNotAlpha(e.key) && e.key !== ' ') {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="otherVariety"
                message={'Other variety is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
        <FormGroup>
          <p>
            <strong>Oat Cooking Type {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={oatCookingTypeOptions}
            defaultValue={{
              label: packaging.CookingType,
              value: packaging.CookingType,
            }}
            name="CookingType"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Oat Cooking Type'}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              return selected
            }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="CookingType"
              message={'⚠ This selection is required.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>{' '}
        </FormGroup>
      </Col>
    </Row>
  )
}

OatsOatmealPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default OatsOatmealPackageReview
